import './TechReport.scss';
import Control from "../../1. Core/Control";
import TopAppBar from "../../1. Core/Controls/TopAppBar/TopAppBar";
import NP from "../../1. Core/NP";
import Delegate from "../../1. Core/Delegate";
import TechTable from "./TechTable";
import JudgeTable from "./JudgeTable";
import {ServerAPI} from "../../1. Core/ServerAPI";
import JudgePointsTable from "./JudgePointsTable";
import Label from "../../1. Core/Controls/Label/Label";
import {IBattle} from "../types";


export default class TechReport extends Control {
	private _topAppBar: TopAppBar;
	private EvClosed: Delegate;
	private _techTable: TechTable;
	private _judgeTable: JudgeTable;
	private _scrollNode: HTMLElement;
	private _judgePointsTable: JudgePointsTable;
	private _resultLabel: Label;
	private _Battle: IBattle;


	_initFields(settings: object)
	{
		this.EvClosed = new Delegate();
		this._Battle = null;
		super._initFields(settings);
	}

	constructor(settings?: object)
	{
		super(settings);
		this._render();
	}

	_render()
	{
		this._initComponent('<div class="tech-report"></div>');

		this._topAppBar = new TopAppBar({
			Class: 'top-app-bar--no-shadow top-app-bar--light top-app-bar--white',
			Caption: 'test',
			ParentNode: this._root,
			MainButton: {
				FontImage: NP.FontImages.close,
				EvClick: () => this.EvClosed.fire(this)
			},
		});

		this._scrollNode = NP.createNode(this._root, 'tech-report__scroll-node');

		this._techTable = new TechTable({
			ParentNode: this._scrollNode
		});
		this._judgeTable = new JudgeTable({
			ParentNode: this._scrollNode
		});

		this._judgePointsTable = new JudgePointsTable({
			ParentNode: this._scrollNode
		});
		this._resultLabel = new Label({
			ParentNode: this._scrollNode
		});

		if (this._ParentNode)
			this.putToNode(this._ParentNode);
	}

	refresh(battle: IBattle)
	{
		this._Battle = battle;

		if (this._Battle.WinnerName)
			this._resultLabel.setContent(NP.RM.getString("WinType").replace("{0}", this._Battle.WinnerName) + " "
				 + NP.RM.getString("WinType_" + this._Battle.WinType) +
				 (this._Battle.WinType == 'WP' ? (' ' + this._Battle.RedPoints + "-" + this._Battle.BluePoints) : ''));
		else
			this._resultLabel.setContent(NP.RM.getString("Draw"));

		this._techTable.clear();
		if (this._judgeTable)
			this._judgeTable.clear();
		if (this._judgePointsTable)
			this._judgePointsTable.clear();

		ServerAPI.get(`/report-box/calcJudgeReportData/${battle.Id}`).then((res: ITechReportData) =>
		{
			this._techTable.refresh(res.TechData);

			NP.setIsVisible([this._judgeTable, this._judgePointsTable], this._Battle.WinType == 'WP');
			if (this._Battle.WinType == 'WP')
			{
				if (this._judgeTable)
					this._judgeTable.refresh(res.JudgePoints, res.TechData);
				if (this._judgePointsTable)
					this._judgePointsTable.refresh(res.ForJudgePoints);
			}
		});
	}

	setCaption(value: string)
	{
		this._topAppBar.setCaption(value);
	}
}

export interface ITechReportData {

	TechData: number[][],
	JudgePoints: Slice,
	ForJudgePoints: Slice
}

export interface Slice {
	LeftSlots?: string[];
	TopSlots?: string[];
	Data?: number[][];
}